import React from "react";
import Select from "react-select";
import EmptyTable from "views/components/EmptyTable";

export const formatSelectOption = function (
  options
) {
  const newOptions = [];
  for (let i = 0; i < options?.length; i++) {
      console.log(options[i]);
      newOptions.push({
        value: `${options[i].id}`,
        label: `${options[i].identite?.firstname} ${options[i].identite?.lastname}`,
      });
  }
  return newOptions;
};

const TableRow = ({ category, data, staffs, onChangeProcessing, t }) => {
  if (!category.claim_objects) return null;

  return category.claim_objects.map((object, i) => (
    <tr key={i} role="row" className="odd">
      {i === 0 ? (
        <td rowSpan={category.claim_objects.length}>{category.name.fr}</td>
      ) : (
        <td style={{ display: "none" }} />
      )}
      <td>{object.name.fr}</td>
      <td>
        {staffs ? (
          <Select
            value={data[object.id]}
            onChange={(e) => onChangeProcessing(e, object.id)}
            options={[
              {
                value: "all",
                label: (
                  <strong>
                    <em>Tout sélectionner</em>
                  </strong>
                ),
              },
              ...formatSelectOption(staffs),
            ]}
            isMulti
            placeholder={t("Veuillez sélectionner le circuit")}
            key={object.id}
          />
        ) : null}
      </td>
    </tr>
  ));
};

const SuperiorRulesTable = ({
  claimObject,
  showList,
  data,
  staffs,
  onChangeProcessing,
  t,
}) => {
  return (
    <table
      className="table table-striped- table-bordered table-hover table-checkable dataTable dtr-inline"
      id="myTable"
      role="grid"
      aria-describedby="kt_table_1_info"
      style={{ width: "952px" }}
    >
      <thead>
        <tr role="row">
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "80px" }}
            aria-label="Ship City: activate to sort column ascending"
          >
            {t("Catégorie de plainte")}
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "100px" }}
            aria-label="Ship City: activate to sort column ascending"
          >
            {t("Objets de plainte")}
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "170px" }}
            aria-label="Ship City: activate to sort column ascending"
          >
            {t("Agents à notifier")}
          </th>
        </tr>
      </thead>
      <tbody>
        {claimObject ? (
          showList.length > 0 ? (
            showList.map((category, index) => (
              <TableRow
                key={index}
                category={category}
                data={data}
                staffs={staffs}
                onChangeProcessing={onChangeProcessing}
                t={t}
              />
            ))
          ) : (
            <EmptyTable search={true} />
          )
        ) : (
          <EmptyTable />
        )}
      </tbody>
    </table>
  );
};

export default SuperiorRulesTable;
